import axios from 'axios';
import { tokenStorage } from './tokenStorage';

// Always use the deployed Firebase Cloud Functions API as the backend
// This avoids localhost/port issues on Android and in production.
const API_BASE_URL = 'https://us-central1-doc-widget-tracker-prod.cloudfunctions.net/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 seconds timeout for mobile networks
});

// Request interceptor to add JWT token from storage
api.interceptors.request.use(
  async (config) => {
    try {
      // Get token from storage (works for both web and mobile)
      const token = await tokenStorage.getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      // Silently handle token retrieval errors
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Enhanced error logging for debugging (especially useful for Android)
    if (error.code === 'ECONNABORTED') {
      console.error('API Request Timeout:', {
        url: error.config?.url,
        method: error.config?.method,
        message: 'Request timed out after 30 seconds'
      });
    } else if (error.message === 'Network Error' || !error.response) {
      console.error('API Network Error:', {
        url: error.config?.url,
        method: error.config?.method,
        message: 'Network request failed. Check internet connection.',
        error: error.message
      });
    } else {
      console.error('API Error Response:', {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data
      });
    }
    
    if (error.response?.status === 401) {
      const message = error.response?.data?.message || '';
      if (
        typeof window !== 'undefined' &&
        (message.includes('another device') || message.includes('Session expired'))
      ) {
        localStorage.setItem('auth_logout_reason', 'Your account was logged in on another device. Please login again.');
      }
      await tokenStorage.removeToken();
      // Only redirect on web, not on mobile
      if (typeof window !== 'undefined' && window.location) {
      window.location.href = '/login';
      }
    }
    // Don't redirect for subscription errors (402) or validation (400)
    return Promise.reject(error);
  }
);

export default api;
